import {type Type} from '@packages/systems/wfdl';
import {listTypeName} from '@packages/systems/wfdl-ast';

export const migrateListDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'List') {
    const newDataType: Type = {
      type: 'TypeApplication',
      val: {
        con: {
          type: 'TypeConstructor',
          val: listTypeName,
        },
        arg: dataTypeJson.of,
      },
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
